import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import '../assets/css/drawer.css';
import { casaIc } from '../funciones/casas.js';
import MenuDrawer from './menu-drawer';
import separador from '../assets/img/separador.png';

var objSesion;

export function irARuta(hash) {
  window.location.hash = hash;
}

function Drawer() {
  const [email, setEmail] = useState('');
  const [usuario, setUsuario] = useState('');
  const [casa, setCasa] = useState('');
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    objSesion = JSON.parse(localStorage.getItem('session'));

    if (!objSesion) return;

    setEmail(objSesion.email);
    setUsuario(objSesion.nombre);
    setCasa(casaIc(objSesion.casa));
  }, []);

  const showDrawer = () => setOpen(true);
  const hideDrawer = () => setOpen(false);

  const irInicio = () => {
    setOpen(false);
    history.push('/Inicio');
  };

  const efecto=()=>{

  };

  const esInicio = location.pathname === '/Inicio';

  return (
    <div className="Sesion">
      <div className="bar">
        <div className="ic-menu">
          {esInicio ? (
            // Ícono de menú (abre Drawer)
            <>
              <i
                className="fas fa-bars menu-icon bars"
                onClick={showDrawer}
              ></i>
            </>
          ) : (
            // Ícono de flecha (regresa a Inicio)
            <>
              <i
                className="fas fa-arrow-left menu-icon arrow visible"
                onClick={irInicio}
              ></i>
            </>
          )}
        </div>
      </div>

      {/* Fondo del Drawer */}
      <div
        className={`backdrop ${open ? '' : 'backdrop-hide'}`}
        style={{ display: open ? 'block' : 'none' }}
        onClick={hideDrawer}
      ></div>

      {/* Contenedor del Drawer */}
      <div
        className="drawer"
        style={{
          transform: open ? 'translateX(0%)' : 'translateX(-100%)',
        }}
      >
        <div className="drawer-header">
          <div className="div-usr">
            <div className="usr-casa">
              <img src={casa} className="img-responsive" alt="casa" />
            </div>
            <div className="usr">
              <small className="lblUsuario">{usuario}</small>
              <br />
              <small className="lblEmail">{email}</small>
            </div>
          </div>
        </div>

        <div className="drawer-body">
          <MenuDrawer />
          
        </div>
      </div>
    </div>
  );
}

export default Drawer;
